module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aek7A"))).then(() => parcelRequire('3a9aZ'));